import TeamSectionImplementation from '../implementation/sections/TeamSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiTeamSectionDTO,
  TeamSectionDTO,
} from '@lib/strapi/dtos/components/sections/teamSection.dto';

const TeamSection = (props: ComponentProps<TeamSectionDTO>) => {
  return <TeamSectionImplementation {...props}></TeamSectionImplementation>;
};

export default TeamSection;
